module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-5-8a8bf7ae449740a2eb6c23251e3da197.png";